import { createProfileLayout } from './createProfileLayout';
import { updateProfileLayout } from './updateProfileLayout';

export const layouts = {
  createProfileLayout,
  updateProfileLayout,
};
